import { isMobile } from '../../../utils';

const navigationCursor = document.querySelector('.Header__nav__arrow');
const nav = document.querySelectorAll('.Header__menu__link');

function HoverNavigation() {
  if (!this.parentNode.classList.contains('is-hovered')) {
    for (let i = 0; i < nav.length; i += 1) {
      if (nav[i].parentNode.classList.contains('is-hovered')) {
        nav[i].parentNode.classList.remove('is-hovered');
      }
    }

    this.parentNode.classList.add('is-hovered');

    const { width } = this.getBoundingClientRect();
    const { left } = this.getBoundingClientRect();

    navigationCursor.style.width = `${width}px`;
    navigationCursor.style.left = `${left}px`;
    navigationCursor.style.top = '71.5px';
    navigationCursor.style.opacity = 1;
    navigationCursor.style.transform = 'translate(0, -21px)';
  }
}

if (document.querySelector('.Header .menu') && !isMobile()) {
  for (let i = 0; i < nav.length; i += 1) {
    nav[i].addEventListener('mouseenter', HoverNavigation);
  }
}
